import json from './sprite.js';

export default {
    handle: 'ENG_SPT11-Pool_225002889',
    label: 'en_SPT11-Pool_225002889',
    json,
};
